import React, { useCallback, useEffect, useState } from 'react';
import { Avatar, Divider, Flex, Layout } from 'antd';
import SiderComponent from './siderComponent';
import HeaderComponent from './headerComponent';
import MenuComponent from './menuComponent';
import { RootState, useStoreDispatch } from '../store';
import {
  getResources,
  setFetchedResources,
  setTypeContainers,
  setTypeDepartment, setTypeDepartmentEn,
  setTypeQuality, setTypeQualityEn,
} from '../store/resources';
import { useSelector } from 'react-redux';
import socket from '../socket';
import { RouteNames } from '../router/routeNames';
import { setAuth,setUserInfo } from '../store/users';
import { useNavigate } from 'react-router-dom';
import { ExitIcon } from '../assets/image/svg';
import Cookies from 'js-cookie';
import { Utils } from '../utils';
import { useTranslation } from 'react-i18next';
import {exit, ping} from "../store/bids";

const {
  Header,
  Sider,
  Content,
} = Layout;

const Layouts = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useStoreDispatch();
  const route = useNavigate();
  const router = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const hasFetchedResources = useSelector((state: RootState) => state.resources.hasFetchedResources);
  const userInfo = sessionStorage.getItem('_yl105000');

  useEffect(() => {
    if (userInfo) {
      const jRes = Utils.decrypt(userInfo)
      if (jRes.length === 0) {
        Cookies.remove('Bearer');
        dispatch(setAuth(false));
      }else {
        dispatch(setUserInfo(jRes))
      }
    }else {
      dispatch(setAuth(false));
    }
  },[]);

  useEffect(() => {
    if (!hasFetchedResources) {
      dispatch(getResources());
      dispatch(setFetchedResources(true));
    }
    socket.on('return-resources', resResources);
    socket.on('refreshToken', refreshToken);

    return () => {
      socket.off('return-resources', resResources);
      socket.off('refreshToken', refreshToken)
    };
  }, []);

  const refreshToken = (response: any) => {
    if (response) {
      dispatch(ping())
    }
  };


  const resResources = useCallback((response: any) => {
    dispatch(setTypeContainers(response.arContainers));
    dispatch(setTypeQuality(response.arQuality));
    dispatch(setTypeQualityEn(response.arQualityEn));
    dispatch(setTypeDepartment(response.arDepartment));
    dispatch(setTypeDepartmentEn(response.arDepartmentEn));
  }, []);

  const exits = () => {
    sessionStorage.removeItem('_yl105000');
    dispatch(exit())
    dispatch(setAuth(false));
    router(RouteNames.LOGIN);
  };

  return (
    <Layout className={'layout'}>
      <Sider width={252}
             collapsedWidth={60}
             className={'layout__background sider'}
             collapsed={collapsed}
             collapsible
             trigger={null}>
        <SiderComponent setCollapsed={setCollapsed} collapsed={collapsed} />
        <MenuComponent collapsed={collapsed} />
        <Divider />
        <Flex align={'center'} className={'box__exit'}
              onClick={exits}
              style={!collapsed ? { paddingLeft: 24 } : { placeContent: 'center', paddingLeft: 0 }}>
          <Avatar shape="circle" src={<ExitIcon />} style={{ marginRight: 1 }} />
          {!collapsed && <div>{t('Exit')}</div>}
        </Flex>
      </Sider>
      <Layout>
        <Header className={'layout__background header'}>
          <HeaderComponent setCollapsed={setCollapsed} collapsed={collapsed} />
        </Header>
        <Content className={'content__background'}>{props.children}</Content>
      </Layout>
    </Layout>
  );
};

export default Layouts;
